var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#fcfcfc",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94141 5.001C6.94114 5.53143 6.73017 6.04004 6.35491 6.41492C5.97965 6.78981 5.47084 7.00027 4.94041 7C4.40997 6.99974 3.90137 6.78877 3.52649 6.41351C3.1516 6.03825 2.94114 5.52943 2.94141 4.999C2.94167 4.46857 3.15264 3.95996 3.5279 3.58508C3.90316 3.21019 4.41197 2.99974 4.94241 3C5.47284 3.00027 5.98144 3.21123 6.35633 3.58649C6.73121 3.96175 6.94167 4.47057 6.94141 5.001ZM7.00141 8.481H3.00141V21.001H7.00141V8.481ZM13.3214 8.481H9.34141V21.001H13.2814V14.431C13.2814 10.771 18.0514 10.431 18.0514 14.431V21.001H22.0014V13.071C22.0014 6.901 14.9414 7.131 13.2814 10.161L13.3214 8.481Z",
    fill: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.379650ddb1c465ed559af9840ce4369e.svg";
export { ForwardRef as ReactComponent };